import React from 'react';
import Footer from '../../components/footer/footer.component';
import BorderedLogo from '../../components/bordered-logo/bordered-logo.component';

export default function SupportPage() {
  return (
    <div className="page-container">
      <div className="mt-60 mb-20">
        <BorderedLogo />
      </div>
      <div className="mt-15">
        <h3 className="text-primary font-bold text-24 mb-30">Support</h3>

        <p className="mb-20">
          For immediate support, please contact our team via phone:
        </p>
        <ul className="mb-30 font-bold">
          <li className="mb-10">+233 243653620</li>
          <li>+233 245866846</li>
        </ul>

        <p className="mb-20">
          You may also use our support form to submit questions or requests:
        </p>
        <a
          href="https://epobee.typeform.com/to/vTF6LOYg?typeform-source=www.epobssuite.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline">
          Ask Questions Here
        </a>
      </div>

      <p className="text-12 text-grey footer">
        &copy; {new Date().getFullYear()} EPOBS Comprehensive School Suite (CSS)
      </p>
    </div>
  );
}
